<template>
  <div class="account-page budget-form" >
    <form v-if="form">
      <AccountPanel title="Adres dostawy">
        <div class="col-12">
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="name">Nazwa</label>
                <input id="name" name="name" class="form-control" type="text" required v-model="form.name.value"
                       @blur="validateField($event, form.name)" />
                <span class="invalid-feedback" v-if="form.name.errors.required">Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="value">Wartość</label>
                <input id="value" name="value" class="form-control" type="number" min="0" step="0.01" required v-model="form.value.value"
                       @blur="validateField($event, form.value)" />
                <span class="invalid-feedback" v-if="form.value.errors.required">Pole nie może być puste</span>
                <span class="invalid-feedback" v-if="form.value.errors.min">Pole musi być większe od 0</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="start">Data rozpoczęcia</label>
                <input id="start" name="start" class="form-control" type="date" required v-model="form.start.value"
                       @blur="validateField($event, form.start)" />
                <span class="invalid-feedback" v-if="form.start.errors.required">Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="finish">Data zakończenia</label>
                <input id="finish" name="finish" class="form-control" type="date" required v-model="form.finish.value"
                       @blur="validateField($event, form.finish)" />
                <span class="invalid-feedback" v-if="form.finish.errors.required">Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12 contact-prefer">
              <div class="contact_button">
                <button class="btn btn-primary" :disabled="!submittable" @click="submit" right>Zapisz budżet</button>
              </div>
            </div>
          </div>
        </div>
      </AccountPanel>
    </form>
  </div>
</template>

<script>

  import { mapState } from 'vuex';
  import Form from "../../../form/src/Form";
  import AccountMenu from './AccountMenu.vue'
  import AccountPanel from './AccountPanel.vue'

  export default {
    components: {AccountPanel},
    data () {
      return {
        form: Form.build({
            name: '',
            value: '',
            start: '',
            finish: ''
        }),
        submitted: false,
        progress: false
      }
    },
    computed: {
      ...mapState({
        company: state => state.company,
      }),
      submittable () {
        return !this.progress && !this.submitted
      }
    },
    methods: {
      ...Form.methods(),
      async submit (evt) {
        let data = this.validateForm(evt, this.form);
        if(this.form.valid) {
          this.progress = true;
          this.submitted = true;
          await this.$store.dispatch('company/createbudget', data);
          this.progress = false;
          this.submitted = false;
          this.$router.replace({name: 'budgets'});
        }

      }
    },
    beforeMount() {
      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }


    },

  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/BudgetForm.vue